/**
 * @fileoverview POST handler for the "/apps/:app_group_id/charts/sessions_previous_window" endpoint
 */
import fetch from "@lib/fetch";
import { jsonToFormData } from "@lib/reportingMetrics";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsSessionsPreviousWindowCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdChartsSessionsPreviousWindowProps,
  AppsAppGroupIdChartsSessionsPreviousWindowResult,
} from "./types";

export const postAppsAppGroupIdChartsSessionsPreviousWindow = reactQueryMutationAdapter(
  appsAppGroupIdChartsSessionsPreviousWindowCacheKeys,
  ({
    appGroupId,
    startDate,
    endDate,
    appIds,
  }: PostAppsAppGroupIdChartsSessionsPreviousWindowProps): Promise<AppsAppGroupIdChartsSessionsPreviousWindowResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/sessions_previous_window`,
      "POST",
      {},
      {
        body: jsonToFormData({
          app_group_id: appGroupId,
          start_date: startDate,
          end_date: endDate,
          app_ids: appIds,
        }),
      },
      {
        setContentType: false,
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
